var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upgrades-list"},[_c('label',[_vm._v("Extras")]),_c('ul',{staticClass:"_list"},_vm._l((_vm.upgrades),function(upgrade){return _c('li',{key:upgrade.id},[_vm._v(" "+_vm._s(upgrade.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }